import React from 'react';
import { connect } from 'react-redux';
import clsx from 'clsx';

import { Box, Size } from '@americanexpress/aqx-components';
import { SectionTitle } from 'page_modules/business-pdp/components/SectionTitle';

import {
  getAprRateData,
  shouldRenderAprBoxForCard
} from 'page_modules/business-pdp/redux';

import styles from './__styles__/aprBox.scss?modules';

const aprBox = React.memo(({ rateData, shouldRenderForCurrentCard }) => {
  const allowRender = !!rateData && shouldRenderForCurrentCard;
  return (
    <div
      className={clsx(styles.aprBoxWrap, {
        [styles.needToRender]: !!allowRender
      })}
    >
      {allowRender && (
        <React.Fragment>
          <SectionTitle text={rateData.header} />
          <Box
            $border={true}
            className={styles.content}
            theme={{
              paddingTop: 25,
              paddingBottom: 25,
              paddingLeft: 20,
              paddingRight: 20,
              rounded: Size.SM
            }}
          >
            {rateData.rate}
          </Box>
        </React.Fragment>
      )}
    </div>
  );
});

const mapStateToProps = state => ({
  rateData: getAprRateData(state),
  shouldRenderForCurrentCard: shouldRenderAprBoxForCard(state)
});

export const AprBox = connect(mapStateToProps)(aprBox);
